import onReplyByImInternal from './onReplyByImInternal';
import Message from 'owa-service/lib/contract/Message';
import * as React from 'react';

export default function onReplyAllByIm(message: Message) {
    return (event: React.MouseEvent<HTMLElement>) => {
        onReplyByImInternal(true /* isReplyAll */, message);
    };
}
